import eagleAviationLogo from '../../assets/eagle-aviation-logo.png';

type BrandLogoSize = 'sm' | 'md' | 'lg';

interface BrandLogoProps {
  size?: BrandLogoSize;
  className?: string;
  containerClassName?: string;
}

const sizeClasses: Record<BrandLogoSize, string> = {
  sm: 'h-8',
  md: 'h-10',
  lg: 'h-14',
};

const BrandLogo = ({
  size = 'md',
  className = '',
  containerClassName = '',
}: BrandLogoProps) => {
  return (
    <div className={`inline-flex items-center rounded-md bg-white px-2 py-1 shadow-sm ${containerClassName}`.trim()}>
      <img
        src={eagleAviationLogo}
        alt="Eagle Aviation"
        className={`w-auto object-contain ${sizeClasses[size]} ${className}`.trim()}
      />
    </div>
  );
};

export default BrandLogo;
